import { render } from "./HRAddDocument.vue?vue&type=template&id=630522a5&scoped=true"
import script from "./HRAddDocument.vue?vue&type=script&lang=js"
export * from "./HRAddDocument.vue?vue&type=script&lang=js"

import "./HRAddDocument.vue?vue&type=style&index=0&id=630522a5&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630522a5"]])

export default __exports__